import { ServerRootService } from "@se/platform";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IListInfoObject } from "./list-info";

@Injectable({
    providedIn: 'root',
})

export class ListInfoClientService extends ServerRootService {

    private readonly endPoint = '/List/GetListInfo';
    private readonly url = this.getServerRoot() + this.endPoint;

    constructor (private httpClient : HttpClient) {
        super();
    };

    // TODO verificare endPoint

    getListInfo(lsName: string): Observable<IListInfoObject> {
        return this.httpClient.get<IListInfoObject>(
            this.url,
            {
                params: { lsName }
        });
    };
}
